module.exports = __webpack_public_path__ + "img/desc.032990a0.png";